export const formatCardBrand = (brand?: string) => {
  if (!brand) return "Card";
  return brand.charAt(0).toUpperCase() + brand.slice(1);
};
